import { Tooltip, IconButton } from "@mui/material";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import { LyftRideInfo } from "../utils/LyftRide";
import { LYFT_RIDE_STATUSES } from "../utils/constants";

const CourtesyRidesButton = ({ rowData, handleLyftDialog }) => {

  const forRequestRide = rowData?.CourtesyRidesData?.[0].status !== LYFT_RIDE_STATUSES.canceled;

  return (
    <Tooltip title={(!rowData?.CourtesyRidesData || !forRequestRide) ? "Request a courtesy ride" : `Ride status: ${LyftRideInfo[rowData.CourtesyRidesData[0].status].title}`}>
      <IconButton
        onClick={() => handleLyftDialog(rowData)}
        size="small"
        className={`icon-button 
          ${(!rowData?.CourtesyRidesData || !forRequestRide) && 'bg-red-button hover:bg-red-dark'}
          ${(rowData?.CourtesyRidesData && forRequestRide) && 'bg-green-button hover:bg-green-dark'}
          `
        }
      >
        <LocalTaxiIcon color='white' />
      </IconButton>
    </Tooltip>
  )
}

export default CourtesyRidesButton;